import { z } from 'zod';
import { estimatingCurrencyCodeSchema, estimatingEstimateStatusSchema, estimatingEstimatesCapability, estimatingMoneyCentsSchema, } from './estimating-estimate.contract.js';
const nullableText = (maximum) => z.string().trim().max(maximum).nullable();
export const estimatingInsuranceClaimsCurrentEstimateLineSchema = z.strictObject({
    lineKey: z.string().uuid(),
    lineNumber: z.number().int().positive(),
    sourceId: nullableText(240),
    sourceLabel: nullableText(240),
    groupLabel: nullableText(120),
    name: z.string().trim().min(1).max(240),
    description: nullableText(4_000),
    quantityTenThousandths: z.number().int().min(1).max(10_000_000),
    unit: z.string().trim().min(1).max(60),
    unitPriceCents: estimatingMoneyCentsSchema,
    lineTotalCents: estimatingMoneyCentsSchema,
});
export const estimatingInsuranceClaimsCurrentEstimateSlot = 'insurance-claims.current-estimate-facts';
export const estimatingInsuranceClaimsCurrentEstimateProviderId = 'estimating.server.insurance-claims-current-estimate';
export const estimatingInsuranceClaimsReadinessProviderId = 'estimating.server.insurance-claims-readiness';
export const estimatingInsuranceClaimsCurrentEstimateRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(estimatingEstimatesCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: z.string().uuid(),
    preferredSourceId: z.string().uuid().nullable().default(null),
    projectId: z.string().uuid(),
});
export const estimatingInsuranceClaimsCurrentEstimateFactSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(estimatingEstimatesCapability),
    estimateId: z.string().uuid(),
    estimateVersionId: z.string().uuid(),
    projectId: z.string().uuid(),
    status: estimatingEstimateStatusSchema,
    revision: z.number().int().positive(),
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    title: z.string().trim().min(1).max(240),
    currencyCode: estimatingCurrencyCodeSchema,
    totalCents: estimatingMoneyCentsSchema,
    lines: z.array(estimatingInsuranceClaimsCurrentEstimateLineSchema).min(1).max(500),
});
export const estimatingInsuranceClaimsCurrentEstimateResponseSchema = z.discriminatedUnion('state', [
    estimatingInsuranceClaimsCurrentEstimateFactSchema,
    z.strictObject({
        state: z.literal('unavailable'),
        capability: z.literal(estimatingEstimatesCapability),
        reasonCode: z.enum(['no-current-estimate', 'preferred-estimate-not-found']),
    }),
]);
//# sourceMappingURL=estimating-insurance-claims-provider.contract.js.map